import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isHome && !scrolled
          ? 'bg-transparent'
          : 'bg-background-50/95 backdrop-blur-sm border-b border-background-200/70'
      }`}
    >
      <div className="w-full px-6 md:px-10">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className={`font-heading text-xl font-semibold whitespace-nowrap cursor-pointer ${
            isHome && !scrolled ? 'text-white' : 'text-foreground-900'
          }`}>
            校园春色
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                isHome && !scrolled
                  ? 'text-white/90 hover:text-white'
                  : 'text-foreground-700 hover:text-primary-600'
              } ${location.pathname === '/' ? (isHome && !scrolled ? 'text-white' : 'text-primary-600') : ''}`}
            >
              首页
            </Link>
            {categories.slice(0, 4).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                  isHome && !scrolled
                    ? 'text-white/80 hover:text-white'
                    : 'text-foreground-600 hover:text-primary-600'
                } ${location.pathname === `/category/${cat.slug}` ? (isHome && !scrolled ? 'text-white' : 'text-primary-600') : ''}`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors ${
                isHome && !scrolled
                  ? 'text-white/80 hover:text-white'
                  : 'text-foreground-600 hover:text-primary-600'
              } ${location.pathname === '/about' ? (isHome && !scrolled ? 'text-white' : 'text-primary-600') : ''}`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer rounded-md ${
              isHome && !scrolled ? 'text-white' : 'text-foreground-700'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-6 py-3 flex flex-col gap-2">
            <Link to="/" className="py-2.5 text-sm font-medium text-foreground-700 hover:text-primary-600 cursor-pointer whitespace-nowrap">首页</Link>
            {categories.map((cat) => (
              <Link key={cat.slug} to={`/category/${cat.slug}`} className="py-2.5 text-sm font-medium text-foreground-600 hover:text-primary-600 cursor-pointer whitespace-nowrap">
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="py-2.5 text-sm font-medium text-foreground-600 hover:text-primary-600 cursor-pointer whitespace-nowrap">关于我们</Link>
          </div>
        </div>
      )}
    </nav>
  );
}